export const types = [
  {
    value: "1",
    name: "Essay of any type",
  },
  {
    value: "2",
    name: "Scholarship essay",
  },
  {
    value: "3",
    name: "Admission essay",
  },
  {
    value: "4",
    name: "College essay",
  },
  {
    value: "5",
    name: "Coursework",
  },
];

export type UnitField = "words" | "pages";
